// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".teaser-section{padding-top:2rem;padding-bottom:6rem}.teaser-section.spacer{padding-top:202px;padding-bottom:213px}.teaser-section p{line-height:1.5}.teaser-section h3{line-height:.93333}.teaser-section .visual{margin-bottom:32px}@media (min-width:1024px){.teaser-section .visual{margin-bottom:0}}.teaser-section .visual img{height:auto;width:100%}@media (min-width:1024px){.teaser-section .visual img{min-height:491px}}", ""]);
// Exports
module.exports = exports;
